<template>
  <div
    class="flex flex-col space-y-12"
    :class="{
      'bg-hint p-8 rounded-lg': index > 0,
    }">
    <b>
      <span class="text-16px leading-18px title-divided self-start">
        Информация о захоронении
      </span>
      <span
        class="text-16px leading-18px title-divided self-start"
        v-if="type === 'family'">
        ({{ parseInt(localIndex, 10) + 1 }})
      </span>
    </b>
    <div class="grid-x grid-padding-x -mx-4 mt-6">
      <div class="cell auto flex flex-col space-y-6">
        <Input
          label="ФИО"
          placeholder="Введите ФИО"
          :classes="$classnames('border-none', {
            'bg-hint': localIndex === 0,
            'bg-white': localIndex > 0,
          })"
          :value="_primary.name"
          @input="($event) => {
            persons = {
              index: 0,
              value: {
                name: $event,
              },
            };
          }"/>
        <div class="input-group">
          <label>Наличие и тип цоколя</label>
          <Select
            :class="$classnames('border-none', {
              'bg-hint': localIndex === 0,
              'bg-white': localIndex > 0,
            })"
            :options="pedestals"
            :value="burial.pedestal"
            @input="($event) => burial.pedestal = $event"
            placeholder="Выберите наличие и тип цоколя"/>
        </div>
        <div class="input-group">
          <label>Тип цветника</label>
          <Select
            :class="$classnames('border-none', {
              'bg-hint': localIndex === 0,
              'bg-white': localIndex > 0,
            })"
            :options="flowerGardens"
            :value="burial.flowerGarden"
            @input="($event) => burial.flowerGarden = $event"
            placeholder="Выберите тип цветника"/>
        </div>
      </div>
      <div class="cell auto flex flex-col space-y-6">
        <Input
          label="Период жизни"
          placeholder="ДД-ММ-ГГГГ - ДД-ММ-ГГГГ"
          :classes="$classnames('border-none', {
            'bg-hint': localIndex === 0,
            'bg-white': localIndex > 0,
          })"
          :disabled="true"
          :value="_primary.lifeDates"
          @click.native="onLifeDatesClick(0)"/>
        <div class="input-group">
          <label>Тип памятника</label>
          <Select
            :class="$classnames('border-none', {
              'bg-hint': localIndex === 0,
              'bg-white': localIndex > 0,
            })"
            :options="headstones"
            :value="burial.headstone"
            @input="($event) => burial.headstone = $event"
            placeholder="Выберите тип памятника"/>
        </div>
      </div>
    </div>
    <div class="flex flex-col space-y-6">
      <b class="text-16px leading-18px title-divided self-start">
        Фото захоронения
      </b>
      <ObjectAttachments
        v-model="burial.photoAttaches"/>
    </div>
    <div class="flex flex-col">
      <b class="text-16px leading-18px title-divided self-start">
        Комментарий
      </b>
      <div class="mt-6">
        <Input
          :textarea="true"
          placeholder="Введите комментарий"
          classes="border-muted-light"
          v-model="burial.comment"/>
      </div>
    </div>
    <template v-if="secondary.length">
      <div
        v-for="(person, index) in _secondary"
        :key="index"
        class="flex flex-col space-y-12 p-8 rounded-lg"
        :class="$classnames({
          'bg-hint': localIndex === 0,
          'bg-white': localIndex > 0,
        })">
        <b>
          <span class="text-16px leading-18px title-divided self-start">
            Информация о подзахоронении
          </span>
          <span
            class="text-16px leading-18px title-divided self-start"
            v-if="type === 'family'">
            ({{ index + 1 }})
          </span>
        </b>
        <div class="grid-x grid-padding-x -mx-4 mt-6">
          <div class="cell auto flex flex-col space-y-4">
            <Input
              label="ФИО"
              placeholder="Введите ФИО"
              :classes="$classnames('border-none', {
                'bg-white': localIndex === 0,
                'bg-hint': localIndex > 0,
              })"
              :value="person.name"
              @input="($event) => {
                _secondary = { index, value: { name: $event } };
              }"/>
          </div>
          <div class="cell auto flex flex-col space-y-4">
            <Input
              label="Период жизни"
              placeholder="ДД-ММ-ГГГГ - ДД-ММ-ГГГГ"
              :classes="$classnames('border-none', {
                'bg-white': localIndex === 0,
                'bg-hint': localIndex > 0,
              })"
              :disabled="true"
              :value="person.lifeDates"
              @click.native="onLifeDatesClick(index + 1)"/>
          </div>
        </div>
      </div>
    </template>
    <template>
      <span
        class="cursor-pointer flex flex-row items-center justify-center"
        @click="addSecondary()">
        <span class="btn-plus mr-2"></span>
        <b class="text-15px leading-21px text-primary">
          Добавить подзахоронение
        </b>
      </span>
    </template>
    <LifeDatesModal
      :id="`select-life-dates-${index}`"
      :payload="activePerson"
      @input="($event) => onLifeDatesChange($event)"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Input from '@/components/Input.vue';
import Select from '@/components/Select.vue';
import ObjectAttachments from '@/pages/Objects/ObjectNew/Components/ObjectAttachments.vue';
import LifeDatesModal from '@/components/Object/LifeDatesModal.vue';

export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    index: {
      validator: (obj) => typeof obj === 'number' || typeof obj === 'string',
      required: true,
    },
  },
  components: {
    Input,
    Select,
    ObjectAttachments,
    LifeDatesModal,
  },
  data() {
    return {
      burial: this.value,
      localIndex: parseInt(this.index, 10),
      activeIndex: null,
      activePerson: null,
      primary: null,
      secondary: [],
    };
  },
  computed: {
    ...mapGetters({
      enumsGetter: 'settings/selectEnums',
    }),
    headstones() {
      return this.enumsGetter('headstone');
    },
    pedestals() {
      return this.enumsGetter('pedestal');
    },
    flowerGardens() {
      return this.enumsGetter('flowerGarden');
    },
    persons: {
      get() {
        return this.burial.persons;
      },
      set({ index, value }) {
        const data = {
          ...this.persons[index],
          ...value,
        };
        data.lifeDates = this.getLifeDates(data);
        this.burial.persons[index] = data;
        this.splitPersons();
      },
    },
    // eslint-disable-next-line no-underscore-dangle
    _primary() {
      return {
        ...this.primary,
        lifeDates: this.getLifeDates(this.primary),
      };
    },
    _secondary: {
      get() {
        let data = this.secondary;
        data = data.map((person) => ({
          ...person,
          lifeDates: this.getLifeDates(person),
        }));
        return data;
      },
      set({ index, value }) {
        this.persons = {
          index: index + 1,
          value: {
            ...this.secondary[index],
            ...value,
          },
        };
      },
    },
  },
  methods: {
    getLifeDates(model) {
      const birthday = model.birthday.split('-').reverse().join('-');
      const deathday = model.deathday.split('-').reverse().join('-');
      if (birthday && deathday) {
        return [
          birthday,
          deathday,
        ].join(' - ');
      }
      return null;
    },
    addSecondary() {
      this.burial.persons.push({
        name: '',
        birthday: '',
        deathday: '',
      });
    },
    onLifeDatesClick(index) {
      this.activePerson = this.burial.persons[index];
      this.activeIndex = index;
      this.$bvModal.show(`select-life-dates-${this.index}`);
    },
    onLifeDatesChange(event) {
      if (this.activeIndex !== null) {
        this.persons = {
          index: this.activeIndex,
          value: event,
        };
      }
      this.$bvModal.hide(`select-life-dates-${this.index}`);
    },
    splitPersons() {
      const { persons } = this.burial;
      // eslint-disable-next-line prefer-destructuring
      this.primary = persons[0];
      this.secondary = persons.slice(1);
    },
  },
  watch: {
    burial: {
      handler(value) {
        this.$emit('input', value);
        this.splitPersons();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
